import {DependencyList, useState} from 'react';
import {useDebounce} from 'react-use';

const getValueOrCallValueFunction = <T extends any>(value: T | (() => T)): T =>
  value instanceof Function ? value() : value;

export const useDebounceValue = <T extends any>(options: {
  value: T | (() => T);
  ms: number;
  deps: DependencyList;
}): T => {
  const {value: inputValue, ms, deps} = options;

  const [value, setValue] = useState<T>(getValueOrCallValueFunction(inputValue));
  useDebounce(
    () => {
      const newValue = getValueOrCallValueFunction(inputValue);
      if (JSON.stringify(value) !== JSON.stringify(newValue)) {
        setValue(newValue);
      }
    },
    ms,
    deps,
  );

  return value;
};
